import { isAndroidtv } from '@rnv/renative';

import isNative from './isNative';

export default isAndroidtv() || !isNative ? 'dash_url' : 'hls_url';
